const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { MomentSold } from './MomentSold';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { acquiredType } from './MomentOwned';

export class OddSalesList extends BaseObject {
  public moments: MomentSold[] = null
  public numMoments: number = null
  public computedDate: Date = null
  public sellerAddress: string = null
  public buyerAddress: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.moments) this.moments = this.moments.map((po) => new MomentSold(po))
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
  }

  public isSafe(): boolean {
    return true
  }

}



(async () => {
})();
